import { apiClient } from './axios';

import type { TwilioCostsSummary } from '@repo/shared-types';

export const twilioCostsApi = {
  getByPhoneNumber: async (
    month?: string,
    day?: number,
    page?: number,
    pageSize?: number,
    refresh?: boolean,
    phoneNumber?: string,
  ): Promise<TwilioCostsSummary> => {
    const response = await apiClient.get<TwilioCostsSummary>('/twilio-costs/by-phone-number', {
      params: {
        month,
        day: day || undefined,
        page: page || undefined,
        pageSize: pageSize || undefined,
        refresh: refresh ? 'true' : undefined,
        phoneNumber: phoneNumber || undefined,
      },
    });
    return response.data;
  },
};
